import {
    CREATED,
    SHIPPED,
    CANCELLED,
    TRANSFERRED,
    SCHEDULED,
    RELEASED,
    RETURN_REQUESTED,
    RETURN_ACCEPTED,
    RETURN_REFUNDED,
    RETURN_REFUSED,
    EXCHANGE_ACCEPTED,
    EXCHANGED,
    OMS_CREATED,
    OMS_AWAITING_PROCUREMENT_CREATION,
    OMS_PARTIALLY_AWAITING_PROCUREMENT_CREATION,
    OMS_PROCUREMENT_CREATED,
    OMS_PARTIALLY_PROCUREMENT_CREATED,
    OMS_SCHEDULED,
    OMS_PARTIALLY_SHEDULED,
    OMS_UNSCHEDULED,
    OMS_BACKORDERED,
    OMS_ORDER_BEING_PACKED,
    OMS_RELEASED,
    OMS_SHIPPED,
    OMS_SHIPPED_INVOICED,
    OMS_CANCELLED,
    OMS_RETURN_FORM_CREATED,
    OMS_PARTIALLY_RETURN_FORM_CREATED,
    OMS_PARTIALLY_RETURN_ACCEPTED,
    OMS_PARTIALLY_RETURN_REFUNDED,
    OMS_PARTIALLY_RETURN_REFUSED,
    OMS_RETURN_ACCEPTED,
    OMS_RETURN_REFUNDED,
    OMS_RETURN_REFUSED,
    OMS_RETURN_RESHIPPED,
    OMS_PARTIALLY_RETURN_RESHIPPED,
    OMS_EXCHANGED,
    OMS_PARTIALLY_EXCHANGED,
    OMS_EXCHANGE_ACCEPTED,
    OMS_PARTIALLY_EXCHANGE_ACCEPTED,
    OMS_INCLUDED,
    OMS_PARTIALLY_INCLUDED,
    OMS_PARTIALLY_RELEASED,
    OMS_PARTIALLY_SHIPPED,
    OMS_PARTIALLY_SHIPPED_INVOICED,
    OMS_PARTIALLY_ORDER_BEING_PACKED,
} from './constants'

const orderStatusMapper: { [key: string]: string[] } = {
    [CREATED]: [OMS_CREATED],
    [TRANSFERRED]: [
        OMS_AWAITING_PROCUREMENT_CREATION,
        OMS_PARTIALLY_AWAITING_PROCUREMENT_CREATION,
        OMS_PROCUREMENT_CREATED,
        OMS_PARTIALLY_PROCUREMENT_CREATED,
    ],
    [SCHEDULED]: [
        OMS_SCHEDULED,
        OMS_PARTIALLY_SHEDULED,
        OMS_BACKORDERED,
        OMS_UNSCHEDULED,
        OMS_ORDER_BEING_PACKED,
        OMS_PARTIALLY_ORDER_BEING_PACKED,
    ],
    [RELEASED]: [OMS_RELEASED, OMS_PARTIALLY_RELEASED, OMS_INCLUDED, OMS_PARTIALLY_INCLUDED],
    [SHIPPED]: [OMS_SHIPPED, OMS_PARTIALLY_SHIPPED, OMS_SHIPPED_INVOICED, OMS_PARTIALLY_SHIPPED_INVOICED],
    [CANCELLED]: [OMS_CANCELLED],
}

const returnStatusMapper: { [key: string]: string[] } = {
    [RETURN_REQUESTED]: [OMS_RETURN_FORM_CREATED, OMS_PARTIALLY_RETURN_FORM_CREATED],
    [RETURN_ACCEPTED]: [OMS_RETURN_ACCEPTED, OMS_PARTIALLY_RETURN_ACCEPTED],
    [RETURN_REFUNDED]: [OMS_RETURN_REFUNDED, OMS_PARTIALLY_RETURN_REFUNDED],
    [RETURN_REFUSED]: [
        OMS_RETURN_REFUSED,
        OMS_PARTIALLY_RETURN_REFUSED,
        OMS_RETURN_RESHIPPED,
        OMS_PARTIALLY_RETURN_RESHIPPED,
    ],
}

const exchangeStatusMapper: { [key: string]: string[] } = {
    [EXCHANGE_ACCEPTED]: [OMS_EXCHANGE_ACCEPTED, OMS_PARTIALLY_EXCHANGE_ACCEPTED],
    [EXCHANGED]: [OMS_EXCHANGED, OMS_PARTIALLY_EXCHANGED],
}

export function mapOrderStatus(status: string): string {
    const allStatus = {
        ...orderStatusMapper,
        ...returnStatusMapper,
        ...exchangeStatusMapper,
    }
    const orderStatus = Object.keys(allStatus).find((key: string) => {
        return allStatus[key].includes(status)
    })

    return orderStatus || ''
}

export default mapOrderStatus
